import type { ReactNode } from "react";
import { Card } from "../../../ui/card";
import { cn } from "../../../utils/common/cn";

interface StatCardProps {
  label: string;
  value: ReactNode;
  sublabel?: ReactNode;
  accent?: "default" | "amber" | "green" | "red";
  className?: string;
}

const ACCENT_CLASS: Record<NonNullable<StatCardProps["accent"]>, string> = {
  default: "text-foreground",
  amber: "text-amber",
  green: "text-[color:var(--approve)]",
  red: "text-destructive",
};

export function StatCard({
  label,
  value,
  sublabel,
  accent = "default",
  className,
}: StatCardProps) {
  return (
    <Card
      className={cn(
        "flex h-full min-h-[110px] flex-col gap-2 border-border bg-card p-5",
        className,
      )}
    >
      <div className="text-[11px] font-medium uppercase leading-snug tracking-[0.14em] text-amber">
        {label}
      </div>
      <div
        className={cn(
          "text-3xl font-semibold tabular-nums leading-tight",
          ACCENT_CLASS[accent],
        )}
      >
        {value}
      </div>
      {sublabel && (
        <div className="mt-auto text-xs text-muted-foreground">{sublabel}</div>
      )}
    </Card>
  );
}
